module.exports = __webpack_public_path__ + "img/zhiqing.7b2d5a72.png";